import { useAppSelector } from '../../../core/utils';
import { useFetchCurrentVehiclePayment } from '../../../core/apiHooks/useFetchPayment';
import { selectCurrentVehicleFromVehicles, selectCurrentVehicleTrimImage } from '../../../core/reducers/vehicles';
import { selectPrimaryCalculatorIsPaymentMethodCash, selectPrimaryCalculatorPaymentOptions, } from '../../../core/reducers/financialCalculators';
import { selectNameBadge } from '../../../core/reducers/ui';
import useFetchLayoutServiceAssets from '../../../core/apiHooks/useFetchLayoutServiceAssets';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
const useSummaryCard = () => {
    var _a, _b, _c;
    const vehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const { exteriorColorKey, interiorColorKey } = useAppSelector(selectCurrentVehicle);
    const modelImage = useAppSelector(selectCurrentVehicleTrimImage);
    const currentPaymentMethodCash = useAppSelector(selectPrimaryCalculatorIsPaymentMethodCash);
    const primaryCalculator = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const nameBadge = useAppSelector(selectNameBadge);
    const { paymentMethod, paymentFrequency, includeFees, overriddenIsSellingProvince } = primaryCalculator;
    const paymentData = useFetchCurrentVehiclePayment();
    const { data: colorAssets } = useFetchLayoutServiceAssets({
        transmissionId: (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) === null || _a === void 0 ? void 0 : _a.id,
        exteriorColorKey,
        interiorColorKey,
    });
    const bigExteriorImage = (_c = (_b = colorAssets === null || colorAssets === void 0 ? void 0 : colorAssets.exteriorImages) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.src;
    return {
        paymentMethod,
        paymentData,
        showLoader: (paymentData === null || paymentData === void 0 ? void 0 : paymentData.isLoading) || (paymentData === null || paymentData === void 0 ? void 0 : paymentData.isUninitialized),
        showError: paymentData === null || paymentData === void 0 ? void 0 : paymentData.error,
        nameBadge,
        modelImage,
        vehicle,
        currentPaymentMethodCash,
        includeFees,
        overriddenIsSellingProvince,
        paymentFrequency,
        bigExteriorImage,
    };
};
export default useSummaryCard;
